import React from 'react';
import { Helmet } from 'react-helmet';
import { Loader } from 'semantic-ui-react';

// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import Online from 'components/Online';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
import PageWrapper from 'components/PageWrapper';
import LoadingGate from 'components/LoadingGate';
import {
    FERTILIZER_EVENTS_LOAD_NAMESPACE,
    FERTILIZER_EVENT_CREATE_NAMESPACE,
    FERTILIZER_EVENT_DELETE_NAMESPACE,
    FERTILIZER_EVENT_UPDATE_NAMESPACE,
    FERTILIZER_EVENTS_COMPLETE_NAMESPACE,
    FERTILIZER_EVENTS_NAMESPACE
} from 'services/fertilizerEvents/constants';
import ErrorGate from 'components/ErrorGate';
import RoleButton from 'components/RoleButton';
import {
    ADMIN,
    ASSISTANT_MANAGER,
    MANAGER
} from 'components/RoleGate/constants';
import { FERTILIZER_EVENT_CREATE_MODAL } from 'scenes/Fertilizer/constants';
import SaveMessage from 'components/SaveMessage';
import ViewWorksheetButton from 'components/ViewWorksheetButton';
import { WORKSHEET_TYPE_FERTILIZER } from 'services/worksheet/constants';
import PrintWorksheetModal from 'components/PrintWorksheetModal';
import RoleModal from 'components/RoleModal';
import { VIEW_WORKSHEET_MODAL } from 'components/WorksheetForm/constants';
import WorksheetForm from 'components/WorksheetForm';
import EventsCurrentFilter from 'components/PageTitleAndFilters/components/EventsCurrentFilter';
import FertilizerEventsRequest from './components/FertilizerEventsRequest';
import FertilizerEventsVirtualizedTable from './components/FertilizerEventsVirtualizedTable';
import FertilizerEventCreateModal from './components/FertilizerEventCreateModal';
import FertilizerEventEditModal from './components/FertilizerEventEditModal';
import FertilizerEventDeleteButton from './components/FertilizerEventDeleteButton';
import FertilizerEventDeleteModal from './components/FertilizerEventDeleteModal';
import FertilizerEventCopyModal from './components/FertilizerEventCopyModal';
import FertilizerEventCopyButton from './components/FertilizerEventCopyButton';
import FertilizerEventCompleteButton from './components/FertilizerEventCompleteButton';
import FertilizerEventCompleteModal from './components/FertilizerEventCompleteModal';

const { REACT_APP_PROJECT_NAME } = process.env;

const Diary = (): React.ReactElement => (
    <ErrorBoundary
        namespace="FertilizerDiary"
        FallbackComponent={<ErrorBoundaryAlert />}
    >
        <Helmet>
            <title>Diary - {REACT_APP_PROJECT_NAME}</title>
        </Helmet>
        <PageTitleAndFilters
            title="Diary"
            hideFilters
            CustomSearch={
                <EventsCurrentFilter namespace={FERTILIZER_EVENTS_NAMESPACE} />
            }
            Button={
                <React.Fragment>
                    <ViewWorksheetButton
                        worksheetType={WORKSHEET_TYPE_FERTILIZER}
                    />
                    <RoleButton
                        requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                        params={{ [FERTILIZER_EVENT_CREATE_MODAL]: true }}
                        buttonProps={{
                            secondary: true,
                            style: { marginLeft: 8 }
                        }}
                    >
                        Schedule Fertilizer
                    </RoleButton>
                </React.Fragment>
            }
            FirstActionButton={<FertilizerEventCopyButton />}
            SecondActionButton={<FertilizerEventCompleteButton />}
            ThirdActionButton={<FertilizerEventDeleteButton />}
            MessageComponent={
                <SaveMessage
                    namespace={[
                        FERTILIZER_EVENT_CREATE_NAMESPACE,
                        FERTILIZER_EVENT_UPDATE_NAMESPACE,
                        FERTILIZER_EVENT_DELETE_NAMESPACE,
                        FERTILIZER_EVENTS_COMPLETE_NAMESPACE
                    ]}
                />
            }
        />
        <Online>
            <FertilizerEventsRequest />
        </Online>
        <PageWrapper top={0} bottom={50}>
            <LoadingGate
                namespace={FERTILIZER_EVENTS_LOAD_NAMESPACE}
                LoadingComponent={
                    <PageWrapper>
                        <Loader active inline="centered" />
                    </PageWrapper>
                }
            >
                <ErrorGate namespace={FERTILIZER_EVENTS_LOAD_NAMESPACE}>
                    <PageTitleAndFiltersPusher>
                        <FertilizerEventsVirtualizedTable tableId="fertilizerDiary" />
                    </PageTitleAndFiltersPusher>
                </ErrorGate>
            </LoadingGate>
        </PageWrapper>
        <FertilizerEventCreateModal />
        <FertilizerEventEditModal />
        <FertilizerEventDeleteModal />
        <FertilizerEventCopyModal />
        <FertilizerEventCompleteModal />
        <PrintWorksheetModal worksheetType={WORKSHEET_TYPE_FERTILIZER} />
        <RoleModal
            requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
            param={VIEW_WORKSHEET_MODAL}
            ignoreSeason
        >
            <WorksheetForm worksheetType={WORKSHEET_TYPE_FERTILIZER} />
        </RoleModal>
    </ErrorBoundary>
);

export default Diary;
